import { Environment } from '../app/shared/interfaces/environment';

export const environment: Environment = {
  // URL_API: 'https://adminpanelapi-dev.inclub.world',
  // URL_API: 'https://adminpanelapi.inclub.world',
  URL_API: 'https://admingateway-dev.inclub.world',
  URL_CHAT_BOT: 'https://chatbotapi-dev.inclub.world/api/v1.0',
  // URL_CHAT_BOT: 'http://localhost:9001/api/v1.0',
  URL_CHAT_BOT_BASE: 'https://chatbotapi-dev.inclub.world',
  // URL_CHAT_BOT_BASE: 'http://localhost:9001/api/v1.0',
  API_KEY_CHATBOT: 'ASCSEFVCMASLFKEOALSADC!$DAS',
  URL_SUPERVISION: 'https://chatbotsupervision-dev.inclub.world/api/v1.0',
  // URL_SUPERVISION: 'http://localhost:9002/api/v1.0',
};